import React from "react";
import Stepper from "./Stepper";
import Actions from "../actions/Actions";

export const STEPS = {
  INFO: 0,
  PDF_FORM: 1,
  UPLOAD: 2,
  PAYMENT_AND_DELIVERY: 3,
  REVIEW: 4,
};

export const UZOP_STEPS = {
  INFO: 0,
  PDF_FORM: 1,
  UPLOAD: 2,
  REVIEW: 3,
};

function Steps({ children = [] }) {
  return (
    <>
      <Stepper steps={children} />
      {children}
      <Actions />
    </>
  );
}

export default Steps;
